/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-input-slider';
import {
  closeModal, speak, toggleAlwaysPopup, updateSpeed,
} from '../../actions';
import X from '../../assets/login/x.svg';

const TTSModal = (props) => {
  return (
    <div className="accessibility-modal">
      <img onClick={props.closeModal} className="accessibility-x-icon" src={X} alt="x" />
      <div className="tts-header-container">
        <svg width="75" height="65" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.96916 19.3976L7.63571 19.7534C6.53776 20.0464 5.40694 19.3695 5.14712 18.2636L4.84446 16.9754L15.9724 14.0383L17.213 17.8975L18.5062 21.0613C18.7119 21.5644 18.5759 22.139 18.1674 22.4931C17.8719 22.7493 17.4729 22.8546 17.0858 22.7786L16.5434 22.672C16.3106 22.6263 16.0856 22.5468 15.8756 22.436L10.4322 19.5642C9.98165 19.3265 9.45875 19.2669 8.96916 19.3976Z" fill="#1D6BED" />
          <path d="M7.18561 12.9183L5.85017 13.2669C4.75058 13.554 4.12045 14.6957 4.46345 15.7796L4.86302 17.0422L15.9909 14.105L15.0825 10.1581L14.5766 6.78655C14.4962 6.25036 14.0837 5.82051 13.5488 5.71544C13.1617 5.63941 12.7627 5.74473 12.4671 6.00092L12.0529 6.36C11.8751 6.51406 11.7214 6.69356 11.5968 6.89271L8.36493 12.0543C8.09743 12.4815 7.67594 12.7903 7.18561 12.9183Z" fill="#1D6BED" />
          <path d="M16.3261 5.95912C16.3752 5.60584 16.7049 5.35688 17.0592 5.42878C18.7046 5.76269 20.2338 6.52073 21.4858 7.62967C22.8998 8.88211 23.8944 10.5237 24.3391 12.3392C24.7838 14.1547 24.6579 16.0594 23.9779 17.8037C23.3758 19.348 22.3642 20.7028 21.0524 21.7312C20.77 21.9526 20.3609 21.8771 20.1535 21.5841V21.5841C19.9442 21.2884 20.0199 20.8841 20.3021 20.6573C21.3925 19.7806 22.2346 18.6387 22.7405 17.3411C23.3253 15.8411 23.4336 14.203 23.0511 12.6417C22.6687 11.0803 21.8133 9.66859 20.5972 8.59149C19.5453 7.65977 18.2659 7.01608 16.888 6.71914C16.5314 6.64231 16.2766 6.31556 16.3261 5.95912V5.95912Z" fill="#1D6BED" />
          <path d="M16.5646 2.62962C16.6143 2.27175 16.948 2.02014 17.3081 2.08669C19.6373 2.51717 21.805 3.56871 23.5692 5.13115C25.4974 6.83886 26.8537 9.0772 27.4603 11.5527C28.0669 14.0283 27.8955 16.6255 26.9684 19.004C26.1203 21.1802 24.6759 23.0803 22.7997 24.4987C22.5097 24.718 22.0957 24.642 21.8855 24.3452V24.3452C21.6735 24.0457 21.7495 23.6356 22.0407 23.4125C23.692 22.1467 24.9642 20.4618 25.7149 18.5356C26.5455 16.4045 26.6991 14.0773 26.1556 11.8593C25.6121 9.64116 24.3969 7.63562 22.6692 6.10551C21.1076 4.72254 19.1932 3.78629 17.1351 3.39195C16.7722 3.32242 16.5144 2.99069 16.5646 2.62962V2.62962Z" fill="#1D6BED" />
        </svg>
        <h2 onClick={props.speak} className={`tts-header ${props.speechEnabled && 'bolded'}`}>
          Text To Speech
        </h2>
      </div>
      <div className="tts-body">
        <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'}`}>
          Click on any text to hear it spoken aloud! Change the speed below. Try it out with text!
        </p>
        <p>Speed Control:</p>
        <div className="tts-slider-container">
          <Slider
            axis="x"
            xstep={0.1}
            xmin={0.5}
            xmax={2}
            x={props.speed}
            onChange={props.updateSpeed}
            className="tts-slider"
          />
          <div className="tts-slider-label-container">
            <p>x0.5</p>
            <p>x1.0</p>
            <p>x1.5</p>
            <p>x2.0</p>
          </div>
        </div>
        <div className="tts-modal-check-container">
          <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'}`}>
            Don&apos;t show me popup again:
          </p>
          <input type="checkbox" checked={!props.speechAlwaysPopup} onChange={props.toggleAlwaysPopup} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechAlwaysPopup: state.speech.alwaysPopup,
    speechEnabled: state.speech.enabled,
    speed: state.speech.speed,
  }
);

export default connect(mapStateToProps, {
  closeModal, speak, toggleAlwaysPopup, updateSpeed,
})(TTSModal);
